import React, { useRef } from 'react';
import { PanelWithDetails } from '../../../../api/panels';
import PanelsTableRow from './PanelsTableRow';
import TableSkeleton from '../../../BaseComponents/TableSkeleton';
import './PanelsTable.scss';
import downArrow from '../../../../assets/icons/downArrow.png';

interface PanelsTableProps {
  panelsList: PanelWithDetails[];
  isLoading: boolean;
  sortingLoading: boolean;
  onViewPanel: (panel: PanelWithDetails) => void;
  onEditPanel: (panel: PanelWithDetails) => void;
  onDeletePanel: (panelId: number) => void;
  onSort: (field: string) => void;
}

const PanelsTable: React.FC<PanelsTableProps> = ({ 
  panelsList, 
  isLoading, 
  sortingLoading,
  onViewPanel,
  onEditPanel, 
  onDeletePanel,
  onSort
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  if (isLoading) {
    return (
      <div className='panels-container'>
        <div className='panels-table'>
           <div className='table-header'>
             <div className='header-cell'>Name <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('name')} /></div>
             <div className='header-cell'>Catalog ID</div>
             <div className='header-cell'>Body Systems <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('body_system')} /></div>
             <div className='header-cell'>Biomarkers</div>
             <div className='header-cell'>Price</div>
             <div className='header-cell'>Non Discounted Price</div>
             <div className='header-cell'></div>
           </div>
          <div className='table-body' ref={scrollContainerRef}>
            <div className='loading-state'>
              <div className='loading-spinner'></div>
              <div className='loading-text'>Loading panels...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='panels-container'>
      <div className='panels-table'>
         <div className='table-header'>
           <div className='header-cell'>Name <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('name')} /></div>
           <div className='header-cell'>Catalog ID</div>
           <div className='header-cell'>Body Systems <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('body_system')} /></div>
           <div className='header-cell'>Biomarkers</div>
           <div className='header-cell'>Price</div>
             <div className='header-cell'>Non Discounted Price</div>
           <div className='header-cell'></div>
         </div>
        <div className='table-body' ref={scrollContainerRef}>
          {sortingLoading ? (
            <TableSkeleton rows={5} columns={6} />
          ) : panelsList?.length > 0 ? (
            panelsList.map((panel) => (
              <PanelsTableRow
                panelData={panel}
                key={panel.id}
                onViewPanel={onViewPanel}
                onEditPanel={onEditPanel}
                onDeletePanel={onDeletePanel}
              />
            ))
          ) : (
            <div className='empty-state'>
              <div className='empty-text'>No panels found</div>
              <div className='empty-subtext'>Click "Add Panel" to create your first panel.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PanelsTable;

